import React from "react";

interface CheckType {
  size?: string;
}

const Check: React.FC<CheckType> = ({ size = "normal" }) => {
  if (size === "normal") {
    return (
      <svg width="40" height="40" viewBox="0 0 40 40" fill="none">
        <path
          d="M28.769 13.9604C29.2744 14.4616 29.2744 15.2756 28.769 15.7768L18.4177 26.0419C17.9123 26.5431 17.0914 26.5431 16.586 26.0419L11.4103 20.9094C10.9049 20.4081 10.9049 19.5941 11.4103 19.0929C11.9158 18.5917 12.7366 18.5917 13.242 19.0929L17.5039 23.3152L26.9414 13.9604C27.4468 13.4592 28.2676 13.4592 28.7731 13.9604H28.769Z"
          fill="#123333"
        />
      </svg>
    );
  } else {
    return (
      <svg width="24" height="25" viewBox="0 0 24 25" fill="none">
        <path
          d="M19.5163 7.14234C19.9495 7.57197 19.9495 8.26967 19.5163 8.69929L10.6437 17.4979C10.2105 17.9275 9.50694 17.9275 9.0737 17.4979L4.63742 13.0986C4.20419 12.669 4.20419 11.9713 4.63742 11.5417C5.07065 11.112 5.77422 11.112 6.20745 11.5417L9.86045 15.1608L17.9497 7.14234C18.383 6.71272 19.0865 6.71272 19.5198 7.14234H19.5163Z"
          fill="#123333"
        />
      </svg>
    );
  }
};

export default Check;
